import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './QuillEditor.css';

const QuillEditor = () => {
  const [editorValue, setEditorValue] = useState('');

  const handleChange = (value) => {
    setEditorValue(value);
  };

  return (
    <div className="quill-editor">
      <ReactQuill value={editorValue} onChange={handleChange} placeholder="Product Description" />
    </div>
  );
};

export default QuillEditor;
